import { render, staticRenderFns } from "./mobileContent.vue?vue&type=template&id=16daf20c&scoped=true"
import script from "./mobileContent.vue?vue&type=script&lang=js"
export * from "./mobileContent.vue?vue&type=script&lang=js"
import style0 from "./mobileContent.vue?vue&type=style&index=0&id=16daf20c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16daf20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16daf20c')) {
      api.createRecord('16daf20c', component.options)
    } else {
      api.reload('16daf20c', component.options)
    }
    module.hot.accept("./mobileContent.vue?vue&type=template&id=16daf20c&scoped=true", function () {
      api.rerender('16daf20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/creatApp/components/mobileContent.vue"
export default component.exports